import { axios } from '@/utils/request'

const api = {
  goodsOptions: '/badminapi/luck/goodsOptions',
  youhuiquanOptions: '/badminapi/luck/youhuiquanOptions',
  luckDetail: '/badminapi/luck/luckDetail',
  luckList: '/badminapi/luck/luckList',
  luckEdit: '/badminapi/luck/luckEdit',
  luckAdd: '/badminapi/luck/luckAdd',
  luckDelete: '/badminapi/luck/luckDelete',
  setLuckAllStatus: '/badminapi/luck/setLuckAllStatus',
  luckOrderList: '/badminapi/luck/orderList',
  luckResult: '/badminapi/luck/luckResult',
  prizeEdit: '/badminapi/luck/prizeEdit',
  setLuckResult: '/badminapi/luck/setLuckResult',
  saveLuckResult: '/badminapi/luck/saveLuckResult',
  LuckUserDownload:'/badminapi/luck/getLuckUserDownloadUrl'
}

export default api

export function getLuckList(parameter) {
  return axios({
    url: api.luckList,
    method: 'get',
    params: parameter
  })
}

export function getLuckDetail(parameter) {
  return axios({
    url: api.luckDetail,
    method: 'get',
    params: parameter
  })
}
export function getGoodsOptions(parameter) {
  return axios({
    url: api.goodsOptions,
    method: 'get',
    params: parameter
  })
}
export function getYouhuiquanOptions(parameter) {
  return axios({
    url: api.youhuiquanOptions,
    method: 'get',
    params: parameter
  })
}
export function editLuck(parameter) {
  return axios({
    url: api.luckEdit,
    method: 'post',
    data: parameter
  })
}
export function addLuck(parameter) {
  console.log('addLuck');
  console.log(parameter);
  return axios({
    url: api.luckAdd,
    method: 'post',
    data: parameter
  })
}

export function deleteLuck(parameter) {
  return axios({
    url: api.luckDelete,
    method: 'post',
    data: parameter
  })
}


export function setLuckAllStatus(parameter) {
  return axios({
    url: api.setLuckAllStatus,
    method: 'post',
    data: parameter
  })
}
export function getLuckUserList(parameter) {
  return axios({
    url: api.luckOrderList,
    method: 'post',
    data: parameter
  })
}
export function getLuckResult(parameter) {
  return axios({
    url: api.luckResult,
    method: 'post',
    data: parameter
  })
}
export function prizeEdit(parameter) {
  return axios({
    url: api.prizeEdit,
    method: 'post',
    data: parameter
  })
}
export function setLuckResult(parameter) {
  return axios({
    url: api.setLuckResult,
    method: 'post',
    data: parameter
  })
}
export function saveLuckResult(parameter) {
  return axios({
    url: api.saveLuckResult,
    method: 'post',
    data: parameter
  })
}
export function LuckUserDownload(parameter) {
  return axios({
    url: api.LuckUserDownload,
    method: 'get',
    params: parameter
  })
}